import { render, staticRenderFns } from "./TeachersKYC.vue?vue&type=template&id=380a3996&scoped=true&"
import script from "./TeachersKYC.vue?vue&type=script&lang=js&"
export * from "./TeachersKYC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a3996",
  null
  
)

export default component.exports